import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHddNo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 11.93,
			y: -.039,
			width: 1.067,
			height: 16.711,
			rx: .089,
			transform: "rotate(45 11.93 -.04)",
			fill: "#8C8C8C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.428 12.444a.456.456 0 0 1-.457.457H1.828a.453.453 0 0 1-.247-.074l.955-.954H10.4V8.901H5.508l.914-.914h3.977V5.016H9.395l.914-.914h.09V4.01l1.029-1.029v9.463ZM10.97.102c.252 0 .457.204.457.457v1.418l-1.029 1.028V1.13h-8v2.972h6.904l-.914.914h-5.99v2.971h3.018l-.914.914H2.399v2.104l-1.028 1.028V.56c0-.253.204-.457.457-.457h9.143ZM8.8 9.873a.572.572 0 1 1 0 1.144.572.572 0 0 1 0-1.144ZM6.17 6.044c.064 0 .115.052.115.114v.687a.115.115 0 0 1-.114.114H3.542a.115.115 0 0 1-.114-.114v-.687c0-.062.052-.114.114-.114h2.629Zm0-3.886c.064 0 .115.052.115.114v.687a.115.115 0 0 1-.114.114H3.542a.115.115 0 0 1-.114-.114v-.687c0-.062.052-.114.114-.114h2.629Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgHddNo);
export { ForwardRef as ReactComponent };
